import { useState } from "react";
export default function Checkbox(props:{labelledby?: string, required:boolean, value:boolean, onChange: (value: boolean)=>void, onBlur?: ()=>void}){
    const [focus, setFocus] = useState<boolean>(false);

    return <div className={"checkbox result-item__checkbox cursor-pointer" + (props.value ? " checkbox--checked" : "") + (focus ? " checkbox--focus" : "")} >
            <input 
                type="checkbox" 
                aria-labelledby={props.labelledby}
                required={props.required}
                className="checkbox__input" 
                onChange={(event)=>{
                    event.stopPropagation();
                    props.onChange(event.target.checked);
                }} 
                onKeyUp={ (event) => {
                    if ((event.code != " ")  && (event.code != "Enter")) { return } 
                    props.onChange(!props.value);
                }}
                checked={props.value} 
                onFocus={()=>setFocus(true)}
                onBlur={()=>{
                    setFocus(false);
                    if(props.onBlur) { props.onBlur() };
                }}
            />
    </div>
}